document.addEventListener('click', function (e) {
  if (!window.matchMedia('(max-width: 999px)').matches) return;

  const btn = e.target.closest('.mobile-image-nav__btn');
  if (!btn) return;

  e.preventDefault();

  const productCard = btn.closest('product-card');
  if (!productCard) return;

  const mediaContainer = productCard.querySelector('.product-card__media');

  if (
    !mediaContainer ||
    !mediaContainer.querySelector('.product-card__image--secondary')
  ) {
    return;
  }

  if (btn.classList.contains('mobile-image-nav__btn--next')) {
    mediaContainer.classList.add('product-card__media--secondary-shown');
  } else {
    mediaContainer.classList.remove('product-card__media--secondary-shown');
  }
});